import type { CurrentUser } from '@/core/user/models/CurrentUser';
import { container } from 'tsyringe';
import { TagsService } from '@/core/tags/services/TagsService';
import { UpdateTagDTO } from '@/core/tags/DTO/UpdateTagDTO';

export const updateTagUseCase = async (tagId: string, data: UpdateTagDTO, user: CurrentUser): Promise<void> => {
  await container.resolve<TagsService>('TagsService').updateTag(tagId, data, user);
};
